import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import ProjectGateway from '~apis/project';
import { TCreateNewProjectReduxParams } from '~types/feat/project';

export default function* watchCreateNewProject(api: ProjectGateway): SagaWatcherReturnType {
    yield takeEvery('project/projectCreateNewProjectAttempt', handleCreateNewProject, api);
}

function* handleCreateNewProject(api: ProjectGateway, data: PayloadAction<TCreateNewProjectReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const {
        ...restOfPayload
    } = data.payload;

    const response = yield* call([api, api.createNewProject], {
        authToken,
        ...restOfPayload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.projectCreateNewProjectFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.projectCreateNewProjectSuccess());
        yield put(combinedActions.projectSetCreateNewProjectModalIsOpen(false));
        yield put(combinedActions.projectSetProjectListingIndex({ index: 0 }));
        yield put(combinedActions.projectGetProjectListingAttempt());

        toast.success(SuccessMessages.ProjectCreateNewProjectSuccess);
    }
}
